<template>
  <div class="page links">
    <h1 class="title">Links</h1>
    <div class="page__content">
      <h2>Algemeen</h2>
      <ul class="links__container">
        <li v-if="company===3"><a target="_blank" href="">Arbeidsreglement</a></li>
        <li v-if="company!==1"><a target="_blank" href="">Wat is service?</a></li>
        <li><a target="_blank" href="https://billo.be">Billo</a></li>
        <li><a target="_blank" href="https://v-tax.be">V-tax</a></li>
        <li><a target="_blank" href="https://huureenstuur.be">Huur een Stuur</a></li>
      </ul>
      <h2>Locaties</h2>
      <ul class="links__container">
        <li><a target="_blank" href="">Zaventem</a></li>
        <li><a target="_blank" href="">Charleroi</a></li>
        <li><a target="_blank" href="">Oostende</a></li>
        <li><a target="_blank" href="">Luik</a></li>
        <li><a target="_blank" href="">Antwerpen</a></li>
        <li><a target="_blank" href="">Schiphol</a></li>
        <li><a target="_blank" href="">Parijs</a></li>
      </ul>
      <h2>Tools</h2>
      <ul class="links__container">
        <li v-if="company!==1"><a target="_blank" href="">Billo bordje</a></li>
        <li v-if="company!==1"><a target="_blank" href="">Pickup-points TUIFLY</a></li>
        <li v-if="company!==1"><a target="_blank" href="">Wegomlegging voetgangers</a></li>
        <li v-if="company!==1"><a target="_blank" href="">Wegomlegging alle verkeer</a></li>
        <li><a target="_blank" href="">Flightradar</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Links",
  data() {
    return {
      links: [], //todo fetch links
      company: parseInt(this.$store.state.auth.user.BEDRIJF) === 9 ? parseInt(this.$store.state.auth.user.BEDRIJFPORTAAL) : parseInt(this.$store.state.auth.user.BEDRIJF)
    }
  }
}
</script>
